import React from "react"

export function BotegaLogoSmall(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 252 252"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M694.263 122.313C694.263 106.648 708.784 93.457 727.401 93.457H754.454C773.071 93.457 787.592 106.648 787.592 122.313V201.633H771.817V122.313C771.817 113.446 763.728 106.75 754.454 106.75H727.401C718.127 106.75 710.038 113.446 710.038 122.313V128.659H694.263V122.313Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M687.049 169.905C687.049 152.487 703.184 137.876 723.794 137.876H779.705V151.169H723.794C712.528 151.169 702.824 159.286 702.824 169.905C702.824 180.524 712.528 188.641 723.794 188.641H734.471C742.753 188.641 750.767 185.75 756.731 180.504L774.009 165.307L785.4 174.503L768.123 189.7C759.258 197.497 747.161 201.934 734.471 201.934H723.794C703.184 201.934 687.049 187.322 687.049 169.905Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M573.395 101.248C579.416 98.2846 587.194 96.6708 595.367 96.6708H623.55C631.722 96.6708 639.5 98.2846 645.521 101.248C651.025 103.956 657.548 109.177 657.548 117.381V149.742C657.548 157.946 651.025 163.167 645.521 165.875C639.5 168.838 631.722 170.452 623.55 170.452H595.367C587.194 170.452 579.416 168.838 573.395 165.875C567.892 163.167 561.369 157.946 561.369 149.742V117.381C561.369 109.177 567.892 103.956 573.395 101.248ZM576.757 117.698V149.425C576.904 149.682 577.57 150.649 580.139 151.913C583.638 153.635 589.012 154.919 595.367 154.919H623.55C629.904 154.919 635.278 153.635 638.778 151.913C641.347 150.649 642.013 149.681 642.159 149.425V117.698C642.013 117.442 641.347 116.474 638.778 115.21C635.278 113.488 629.904 112.204 623.55 112.204H595.367C589.012 112.204 583.638 113.488 580.139 115.21C577.57 116.474 576.904 117.441 576.757 117.698Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M664.041 93.457L642.159 103.273V149.462H657.548V113.368L670.291 107.651L664.041 93.457Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M655.624 252H584.452C571.703 252 561.369 241.568 561.369 228.701V207.343V176.523L587.22 154.778L597.072 166.71L576.757 183.798V191.81H644.083C650.457 191.81 655.624 197.026 655.624 203.46V252ZM576.757 207.343V228.701C576.757 232.99 580.202 236.467 584.452 236.467H640.236V207.343H576.757Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M536.233 175.346C536.233 190.79 519.288 201.934 500.59 201.934H471.332C452.635 201.934 435.689 190.79 435.689 175.346V121.692H452.362V175.346C452.362 181.737 459.868 188.294 471.332 188.294H500.59C512.055 188.294 519.561 181.737 519.561 175.346V169.699H536.233V175.346Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M536.233 121.692C536.233 105.829 519.94 93.457 500.59 93.457H471.332C451.983 93.457 435.689 105.829 435.689 121.692H452.362C452.362 113.9 460.52 107.096 471.332 107.096H500.59C511.403 107.096 519.561 113.9 519.561 121.692V127.81H536.233V121.692Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M447.838 153.102V139.462L519.561 139.462L519.561 126.749H536.233L536.233 151.102C536.233 152.206 535.337 153.101 534.233 153.101L447.838 153.102Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M369.501 93.4295V60.0795H351.903V176.382C351.903 190.908 369.767 201.934 390.437 201.934H410.553V189.599H390.437C378.262 189.599 369.501 183.268 369.501 176.382V105.765H410.553V93.4295H369.501Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.223 121.215C226.223 106.141 241.911 93.457 262.008 93.457H290.982C311.079 93.457 326.767 106.141 326.767 121.215V174.175C326.767 189.25 311.079 201.934 290.982 201.934H262.008C241.911 201.934 226.223 189.25 226.223 174.175V121.215ZM243.709 121.215V174.175C243.709 182.5 252.236 188.785 262.008 188.785H290.982C300.755 188.785 309.281 182.5 309.281 174.175V121.215C309.281 112.89 300.755 106.606 290.982 106.606H262.008C252.236 106.606 243.709 112.89 243.709 121.215Z"
        fill="var(--mui-palette-text-primary)"
      /> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5865 141.687V125.121C8.32154 125.121 0 132.537 0 141.687V186.367C0 195.517 8.32154 202.933 18.5865 202.933H134.18C169.216 202.933 197.537 177.6 197.537 146.463C197.537 115.227 169.104 89.9935 134.095 89.9935V106.56C158.877 106.56 178.95 124.41 178.95 146.463C178.95 168.467 158.933 186.367 134.18 186.367H18.5865V141.687Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        d="M92.2386 163.049L105.381 174.763L151.778 133.409L105.388 91.9753L92.2317 103.677L117.167 125.948L18.5865 125.121V141.687L116.237 141.659L92.2386 163.049Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.137 82.0163C163.565 82.0163 184.147 63.6714 184.147 41.0081C184.147 18.3446 163.565 0 138.137 0H18.5865C8.32145 0 0 7.41686 0 16.566V103.006H18.5865V16.566H138.137C153.3 16.566 165.561 27.4939 165.561 41.0081C165.561 54.5222 153.3 65.4503 138.137 65.4503V82.0163Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        d="M87.1071 44.013L73.9645 32.299L27.4697 73.7395L73.9714 115.099L87.1002 103.372L63.0887 82.0163H138.137V65.4503H63.0552L87.1071 44.013Z"
        fill="var(--mui-palette-text-primary)"
      />
      {/* <path
        d="M821.107 160.212H849.036H863V174.119V201.934H821.107V181.073V170.642V160.212Z"
        fill="#0DBD29"
      /> */}
    </svg>
  )
}
